import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class BackendService {
    isDev: boolean = false;
    isCloud: boolean = false;
    urlCloud = "https://foton-tunland.com/";
    urlLocal = "http://localhost:8080/";
  constructor(private http:HttpClient) {
  }

  createContact(req) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
    const ep = this.prepEndpoint('api/contacts/create');
    return this.http.post(ep, req, httpOptions)
      .pipe(map((res: any) => res));
  }

  createSeekop(req) {
    return this.http.post("https://www.sicopweb.com/interface/adf/add/prospect.xml", req, {
      headers: new HttpHeaders({
        "Content-type": "application/xml"
      }), 
      responseType: 'text'
    }).pipe(map((res: any) => res));
  }

  getFormulario(req) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
    return this.http.post("https://app.leader.com.ec/api/formularios/public/", req, httpOptions)
      .pipe(map((res: any) => res));
  }

  prepEndpoint(ep) {
    if(this.isDev) {
      return this.urlLocal + ep;
    } else {
      return this.urlCloud + ep; 
    }
  }
}